export class AddUserName {
  public static readonly type = '[User] Add user name';
  public constructor(public userName: string) { }
}

export class RemoveUserName {
  public static readonly type = '[User] Remove user name';
}

export class FetchUserDetailsIfEmpty {
  public static readonly type = '[User] Fetch user details if empty';
}

export class GetUserDetails {
  public static readonly type = '[User] Get user details';
}
